var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.71 13.6786L14.43 13.4288C15.41 12.3742 16 11.005 16 9.51557C16 6.19441 13.09 3.50232 9.5 3.50232C5.91 3.50232 3 6.19441 3 9.51557C3 12.8367 5.91 15.5288 9.5 15.5288C11.11 15.5288 12.59 14.983 13.73 14.0764L14 14.3354V15.0663L18.5926 19.3064C18.8226 19.5188 19.1772 19.5186 19.407 19.306L20.0144 18.7442C20.2709 18.5068 20.2711 18.1013 20.0148 17.8637L15.5 13.6786H14.71ZM4.99992 9.51571C4.99992 7.21217 7.00992 5.35269 9.49992 5.35269C11.9899 5.35269 13.9999 7.21217 13.9999 9.51571C13.9999 11.8192 11.9899 13.6787 9.49992 13.6787C7.00992 13.6787 4.99992 11.8192 4.99992 9.51571Z",
    fill: "#100F0F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.71 13.6786L14.43 13.4288C15.41 12.3742 16 11.005 16 9.51557C16 6.19441 13.09 3.50232 9.5 3.50232C5.91 3.50232 3 6.19441 3 9.51557C3 12.8367 5.91 15.5288 9.5 15.5288C11.11 15.5288 12.59 14.983 13.73 14.0764L14 14.3354V15.0663L18.5926 19.3064C18.8226 19.5188 19.1772 19.5186 19.407 19.306L20.0144 18.7442C20.2709 18.5068 20.2711 18.1013 20.0148 17.8637L15.5 13.6786H14.71ZM4.99992 9.51571C4.99992 7.21217 7.00992 5.35269 9.49992 5.35269C11.9899 5.35269 13.9999 7.21217 13.9999 9.51571C13.9999 11.8192 11.9899 13.6787 9.49992 13.6787C7.00992 13.6787 4.99992 11.8192 4.99992 9.51571Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.72699,
    width: 24,
    height: 22.2028,
    fill: "#100F0F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.aa6b6fa4.svg";
export { ForwardRef as ReactComponent };